<template>
    <journey-builder-composer-zoom
        :proxy="true"
        
        @proxy-zoom-with-wheel="($refs.actualZoom ? $refs.actualZoom.zoomWithWheel : function(){})(...arguments)"
        @proxy-add-pan="($refs.actualZoom ? $refs.actualZoom.addPan : function(){})(...arguments)"
    >
        <div class="composer-root">
            <drag-and-drop-wrapper>
                <template v-slot:="{jsPlumbInstance}">
                    <journey-builder-composer-zoom @scale-changed="zoomChanged(jsPlumbInstance, $event)" @pan-changed="panChanged" ref="actualZoom">
                        <journey-builder-composer-connection-manager
                                :js-plumb-instance="jsPlumbInstance"
                                @connection-created="$emit('connection-created', $event)"
                        >
                            <template v-slot:="{connectNewCircleBricks}">
                                <div class="compose-area">
                                    <template
                                        v-for="brick in journeyBricks"
                                    >
                                        <drag-and-drop-draggable
                                            :key="brick.id"

                                            :js-plumb-instance="jsPlumbInstance"

                                            @start="brickMoveStarted(brick.id)"
                                            @stop="brickMoveStopped"
                                        >
                                            <journey-brick-square-endpoints
                                                :js-plumb-instance="jsPlumbInstance"
                                                :brick-id="brick.id"
                                                :incoming-connections="brick.incomingConnections"
                                                :outgoing-connections="brick.outgoingConnections"
                                                
                                                :accepts-incoming-connections="!brick.isChildJourneyBrick"
                                            >
                                                <component :is="brick.brickComponent"
                                                    :ref="brick.id"
                                                    
                                                    class="composer-component"

                                                    
                                                    :isActive="brick.isActive"
                                                    :id="brick.id"
                                                    :name="brick.name"
                                                    :type="brick.type"
                                                    :config="brick.config"
                                                    :availableConditions="availableConditions"
                                                    :is-child-journey-brick="brick.isChildJourneyBrick"
                                                    :incoming-connections-info="brick.incomingBrickConnections"
                                                    :outgoing-connections-info="brick.outgoingBrickConnections"

                                                    :x="brick.x"
                                                    :y="brick.y"
                                                    :is-new="brick.isNew"

                                                    @add-connection="$emit('add-connection', brick)"
                                                    @delete-brick="$emit('delete', { brick: brick, requiresPrompt: $event })"
                                                    @settings-changed="$emit('settings-changed', Object.assign({id: brick.id}, $event))"
                                                >
                                                </component>
                                            </journey-brick-square-endpoints>
                                        </drag-and-drop-draggable>
                                    </template>

                                    <drag-and-drop-draggable
                                        v-for="{ connector, connection, isActive, isDeduplicationActive } in brickConnectors"
                                        :key="connection.id"
                                        :js-plumb-instance="jsPlumbInstance"

                                        @start="brickMoveStarted(connection.id)"
                                        @stop="connectorMoved(connection.id, connection.sourceBrickId, $event)"
                                    >
                                        <journey-brick-circle-endpoints
                                            :js-plumb-instance="jsPlumbInstance"
                                            :connection-id="connection.id"
                                            :source-brick-id="connection.sourceBrickId"
                                            :destination-brick-id="connection.destinationBrickId"
                                            :is-active="isActive"

                                            @endpoints-updated="connectNewCircleBricks($event.created, connection)"
                                        >
                                            <journey-brick-circle class="composer-component"
                                                :ref="connection.id"
                                                
                                                :is-active="isActive"
                                                :is-deduplication-active="isDeduplicationActive"
                                                :type="connector.type"
                                                :config="connector.config"
                                                :x="connector.connectorX"
                                                :y="connector.connectorY"
                                                :connection="connection"

                                                @change-connection="changeConnection(connection.sourceBrickId, $event)"
                                                @delete-connection="deleteConnection(connection.sourceBrickId, connection.destinationBrickId, $event)"
                                            >
                                            </journey-brick-circle>
                                        </journey-brick-circle-endpoints>
                                    </drag-and-drop-draggable>
                                </div>
                            </template>
                        </journey-builder-composer-connection-manager>
                    </journey-builder-composer-zoom>
                </template>
            </drag-and-drop-wrapper>
        </div>
    </journey-builder-composer-zoom>
</template>

<script>
    import brickDisplayFormats from '../../Bricks/brick-display-formats';
    import {brickDefinitions} from '../../Bricks/brick-definitions';
    
    import {conditionTypes} from "../../ConnectionSettings/condition-types";

    import resourceMixin from "../../../../Util/Mixins/resources";
    import journeyBrickEndpointUuidMixin from '../../Mixins/journey-brick-endpoint-uuid';
    import dateHelpers from '../../Util/date-helpers';

    import Modal from "../../../../Components/Util/Modal.vue";
    
    import JourneyBuilderComposerZoom from "./JourneyBuilderComposerZoom.vue";
    import DragAndDropWrapper from "./../../../../Components/DragAndDrop/DragAndDropWrapper.vue";
    import {default as DragAndDropDraggable} from "./JourneyBuilderComposerDraggable.vue";
    import DragAndDropEndpoints from "./../../../../Components/DragAndDrop/DragAndDropEndpoints.vue";
    
    import JourneyBuilderComposerConnectionManager from "./JourneyBuilderComposerConnectionManager.vue";
    import JourneyBrickSquareEndpoints from "./JourneyBrickSquareEndpoints.vue";
    import JourneyBrickCircleEndpoints from "./JourneyBrickCircleEndpoints.vue";
    
    import JourneyBrickSquare from "./JourneyBrickSquare.vue";
    import JourneyBrickOctagon from "./JourneyBrickOctagon.vue";
    import JourneyBrickCircle from "./JourneyBrickCircle.vue";
    
    export default {
        name: 'journey-builder-composer',
        components: {
            Modal,
            
            DragAndDropWrapper,
            DragAndDropDraggable,
            DragAndDropEndpoints,

            JourneyBuilderComposerZoom,
            JourneyBuilderComposerConnectionManager,
            JourneyBrickSquareEndpoints,
            JourneyBrickCircleEndpoints,
            
            JourneyBrickSquare,
            JourneyBrickCircle
        },
        mixins: [journeyBrickEndpointUuidMixin, resourceMixin],
        methods: {
            brickMoveStarted(brickId){
                this.draggedBrickId = brickId;
            },
            brickMoveStopped(event) {
                const vm = this;
                const brickId = vm.draggedBrickId;
                const [x, y] = event.finalPos;

                vm.draggedBrickId = null;
                
                vm.$emit('brick-moved', {
                    brickId: brickId, 
                    x: x, 
                    y: y
                });
            },
            zoomChanged(jsPlumbInstance, detail){
                jsPlumbInstance.setZoom(detail.scale);
                
                this.panChanged(detail);
            },
            panChanged({x, y, scale}) {
                //HACK: prevent new bricks from being added outside of visible area
                const extraXY = scale > 1 ? 400 : 0;
                
                //X/Y are reversed by our panning framework
                this.$emit('top-left-changed', {
                    x: (-x) + extraXY,
                    y: (-y) + extraXY
                });
            },
            connectorMoved(connectionId, sourceBrickId, event){
                const vm = this;
                const [x, y] = event.finalPos;

                vm.$emit('connector-moved', {
                    connectionId: connectionId,
                    sourceBrickId: sourceBrickId,
                    connectorX: x,
                    connectorY: y
                });

                this.draggedBrickId = null;
            },
            changeConnection(sourceBrickId, event){
                this.$emit('change-connection', {
                    sourceBrickId: sourceBrickId,
                    model: event
                });
            },
            deleteConnection(sourceBrickId, destinationBrickId, event){
                this.$emit('delete-connection', {
                    sourceBrickId: sourceBrickId,
                    destinationBrickId: destinationBrickId,
                    connectionId: event
                });
            }
        },
        watch: {
            draggedBrickId(newValue, oldValue){
                //We want to add the dragging class manually
                //due to Vue's repaint causing a noticeable slowdown
                
                //Value is always toggled between componentRefId/null
                const componentRefId = newValue || oldValue;
                const isDragging = !!newValue;

                const el = this.$refs[componentRefId][0].$el;

                if(isDragging){
                    el.classList.add('dragging');
                }
                else{
                    el.classList.remove('dragging');
                }
            }
        },
        computed: {
            journeyBricks(){
                const vm = this;
                const brickMap = vm.brickMap;
                
                const conditionNameMap = vm.availableConditions.reduce((map, condition) => {
                    map[condition.id] = condition.name;
                    return map;
                }, {});
                
                const mapBrickConnection = (sourceBrick, destinationBrick, connection) => {
                    const sourceConditions = connection.conditions
                        .filter(c => c.type === conditionTypes.action)
                        .map(c => ({ 
                            description: conditionNameMap[c.conditionId],
                            operator: c.operator,
                            type: c.type
                        }));

                    const { conditionId: destinationConditionId } = connection.conditions.find(c => c.type === conditionTypes.arrival) || {};
                    
                    return {
                        connectionId: connection.id,
                        connectionName: connection.name,
                        
                        sourceBrickName: sourceBrick.name,
                        sourceBrickType: sourceBrick.type,
                        sourceBrickConfig: sourceBrick.config,
                        
                        destinationBrickName: destinationBrick.name,
                        destinationBrickType: destinationBrick.type,
                        destinationBrickConfig: destinationBrick.config,
                        
                        sourceConditions: sourceConditions,
                        
                        destinationConditionDescription: conditionNameMap[destinationConditionId]
                    }
                };
                
                return vm.bricks.map(brick => {
                    const brickComponent = brickDefinitions[brick.type].displayFormat === brickDisplayFormats.octagon ?
                            JourneyBrickOctagon :
                            JourneyBrickSquare;
                    
                    const {incomingConnections, outgoingConnections} = brick;
                    
                    return {
                        brickComponent: brickComponent,
                        
                        id: brick.id,
                        incomingConnections: incomingConnections,
                        outgoingConnections: outgoingConnections,

                        isChildJourneyBrick: brick.isChildJourneyBrick,

                        isActive: true,
                        name: brick.name,
                        type: brick.type,
                        config: brick.config,
                        x: brick.x,
                        y: brick.y,
                        isNew: brick.isNew,

                        //We only care about 'full'/'complete' connections for our connection info
                        incomingBrickConnections: incomingConnections
                            .filter(c => c.sourceBrickId)
                            .map(connection => mapBrickConnection(brickMap[connection.sourceBrickId], brick, connection)),
                        
                        outgoingBrickConnections: outgoingConnections
                            .filter(c => c.destinationBrickId)
                            .map(connection => mapBrickConnection(brick, brickMap[connection.destinationBrickId], connection))
                    }
                });
            },
            brickConnectors(){
                const vm = this;
                const brickMap = vm.brickMap;
                
                const today = new Date();
                
                return vm.bricks.reduce((circleBricks, currentBrick) => {
                    //Circle bricks serve as a connection between two bricks
                    //thus, circles should be placed in the center of both bricks
                    const connectionBricks = currentBrick.outgoingConnections
                        .filter(connection => connection.sourceBrickId && connection.destinationBrickId)
                        .map(connection => {
                            //A connection is active when:
                            // * it has a name
                            // * is not disabled
                            // * has either no startDate, or a startDate in the past/of today
                            const isActive = !!connection.name && 
                                !connection.isDisabled &&
                                (!connection.startDate || dateHelpers.getMomentFromString(connection.startDate).isSameOrBefore(today, 'day'));
                            
                            //Deduplication is active when:
                            // * It is not disabled via the config
                            // * A field has been configured
                            const isDeduplicationActive = !!((connection.config.deduplicationSettings && connection.config.deduplicationSettings.fieldName) || undefined) &&
                                ((connection.config.deduplicationSettings && connection.config.deduplicationSettings.isDisabled) || false) === false;
                            
                            return {
                                isActive: isActive,
                                isDeduplicationActive: isDeduplicationActive,
                                connection: connection,
                                connector: {
                                    id: connection.id,
                                    name: connection.name,
                                    connectorX: connection.connectorX,
                                    connectorY: connection.connectorY,
                                    conditions: connection.conditions,
                                    config: { availableConditions: this.availableConditions },
                                    type: brickMap[connection.sourceBrickId].type
                                }
                            };
                        });

                    circleBricks.push(...connectionBricks);
                    
                    return circleBricks;
                }, []);
            },
            brickMap(){
                return this.bricks.reduce((map, currentBrick) => { 
                    map[currentBrick.id] = currentBrick; 
                    return map; 
                }, {});
            }
        },
        data: () => ({
            draggedBrickId: null
        }),
        props: {
            availableConditions: {},
            bricks: {
                type: Array,
                default: () => [{
                    id: '',
                    name: '',
                    type: 1,
                    config: {},
                    connections: [],
                    incomingConnections: [],
                    outgoingConnections: []
                }]
            }
        }
    }
</script>

<style scoped src="../../Style/journey-builder-composer.scss" lang="scss">
</style>